import { createContext } from 'react';
const ChannelContext = createContext(undefined);
export default ChannelContext;
//# sourceMappingURL=ChannelContext.js.map